export const validation = {
  name: 'Name is required.',
  email: 'Email is required.',
  phoneNumber: 'Phone number is required.',
  address: 'Address is required.',
  invalidPhoneNumber: 'Please enter valid phone number.',
  quote: 'Quote is required',
  brand: 'Brand is required',
  requiredCommonMessage : "This field is required. Please make a selection to proceed.",
  validaAddress:'Please enter valid address',
  nameMinimum:'Name at least 2 characters long',
  onlyAlphabetsAllowed:'Please enter valid name',
};
